// extracted by mini-css-extract-plugin
export default {"menuItem":"menuItem_menuItem__X0of6","fullWidthButton":"menuItem_fullWidthButton__W5-Yj"};